<template>
    <div class="column" :class="widthClass">
        <div class="box widget">
            <slot><div class="empty-widget">Empty widget!</div></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Widget",
    props: {
        width: {
            type: Number,
            default: 0
        }
    },
    computed: {
        widthClass() {
            return this.width > 0 ? `is-${this.width}` : "";
        }
    }
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #323232;
}

.empty-widget {
    padding: 150px 0;
}
</style>
